import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const wasteHandoverRegistrationRoutes = ({
    List,
    Create,
    Edit,
}: {
    List: React.ComponentType;
    Create: React.ComponentType;
    Edit: React.ComponentType;
}) => (
    <Routes>
        <Route path={ROUTES.WASTE_HANDOVER_REGISTRATION.LIST_REGISTRATION.BASE} element={<List />} />
        <Route path={ROUTES.WASTE_HANDOVER_REGISTRATION.CREATE} element={<Create />} />
        <Route path={ROUTES.WASTE_HANDOVER_REGISTRATION.EDIT_REGISTRATION.BASE} element={<Edit />} />
    </Routes>
);

